var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draw-place"},[_c('canvas',{attrs:{"id":"canvas"}}),_c('div',{ref:"clear",staticClass:"clear"}),_c('div',{staticClass:"lastik",class:_vm.activeColor})])}
var staticRenderFns = []

export { render, staticRenderFns }